var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"team",attrs:{"id":"team"}},[_c('div',{staticClass:"team__group"},[_vm._l((_vm.teams),function(team,index){return [_c('text-block',{key:index,attrs:{"title":team.title,"content":team.text}})]})],2),_c('footer-part')],1)}
var staticRenderFns = []

export { render, staticRenderFns }